import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import CardFooter from "common/components/Card/CardFooter.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import Assignment from "@material-ui/icons/Assignment";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import loadContent from "core-module/hoc/loadContent";
const importedStyle = dashboardStyle;

const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
};

const RefCodeCard = (props) => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Your Referral Code is</h4>
      </CardHeader>
      <CardBody>
        <GridContainer align="center">
          <GridItem xs={12}>
            <h3 className={classes.cardTitle}>
              {" "}
              <br />
              {props.getData("referral_code")}
              <br />
              <br />
            </h3>
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <small>
          How it works: Help your friends sign-up for service with MCSnet
          through our website, and enter your code into the promo code box. When
          your friend's service is installed, a $50.00 credit will instantly be
          applied to your account and a $50.00 credit will be applied to your
          friend's account. PLEASE NOTE THAT THE REFERRAL CODE MUST BE ENTERED
          DURING THE SIGN-UP PROCESS AND CANNOT BE ADDED DURING OR AFTER THE
          INSTALLATION OF THE SERVICE.
        </small>
      </CardFooter>
    </Card>
  );
};

export default withStyles(styles)(loadContent("user.session", RefCodeCard));
